import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    Stack,
    Chip,
} from '@mui/material';
import RequestService from '../../services/RequestService';

const ChallangeDeleteDialog = ({ open, onClose, challanger, onSuccess }) => {
    const handleSubmit = async () => {
        try {
            await RequestService.deleteChallanger(challanger.id);
            onSuccess();
            onClose();
        } catch (err) {
            console.error('Failed to delete content:', err);
        }
    };

    if (!challanger) {
        return null;
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogContent sx={{ padding: '32px 32px' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: 24,
                            fontWeight: '500',
                            color: '#0C3466',
                            mb: 3,
                        }}
                    >
                        Excluir Desafio
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: 16,
                            fontWeight: '400',
                            color: '#0C3466',
                            mb: 2,
                        }}
                    >
                        Tem certeza que deseja excluir este desafio? Essa ação é
                        irreversível e todos os dados associados a ele serão
                        perdidos.
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: 14,
                            fontWeight: '400',
                            color: '#0C3466',
                            mb: 1,
                        }}
                    >
                        Informações do Desafio
                    </Typography>
                    <Box
                        sx={{
                            padding: '24px 10px',
                            backgroundColor: '#EDF8FF',
                            borderRadius: '8px',
                        }}
                    >
                        <Stack direction="column" spacing={1}>
                            <Typography
                                sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: 14,
                                    fontWeight: '500',
                                    color: '#292929',
                                }}
                            >
                                Título: {challanger.title}
                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: 14,
                                    fontWeight: '400',
                                    color: '#666666',
                                }}
                            >
                                Descrição:{' '}
                                {challanger.description || 'Não informado'}
                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: 14,
                                    fontWeight: '400',
                                    color: '#292929',
                                }}
                            >
                                Grupos:
                            </Typography>
                            <Stack direction="row" gap={2}>
                                {challanger.groups.map((group) => (
                                    <Chip
                                        key={group.id}
                                        label={group.name}
                                        size="small"
                                        color="primary"
                                    />
                                ))}
                                {challanger.groups.length > 3 && (
                                    <Chip
                                        label={`+ ${challanger.groups.length - 1}`}
                                        size="small"
                                        color="primary"
                                    />
                                )}
                            </Stack>
                            <Typography
                                sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: 14,
                                    fontWeight: '400',
                                    color: '#292929',
                                }}
                            >
                                Jogos:
                            </Typography>
                            <Stack direction="row" gap={2}>
                                {challanger.games.map((game) => (
                                    <Chip
                                        key={game.id}
                                        label={game.name}
                                        size="small"
                                        color="primary"
                                    />
                                ))}
                                {challanger.games.length > 3 && (
                                    <Chip
                                        label={`+ ${challanger.games.length - 1}`}
                                        size="small"
                                        color="primary"
                                    />
                                )}
                            </Stack>
                        </Stack>
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined">
                    Cancelar
                </Button>
                <Button
                    onClick={handleSubmit}
                    color="error"
                    variant="contained"
                >
                    Excluir Desafio
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ChallangeDeleteDialog;
